<template>
  <div>
    <h3>Lịch sử chấm BTVN lần {{ is_redo ? "2" : "1" }}</h3>
    <hr>
    <div class="p-8 rounded-lg d-flex" style="background: #f9f7fb; align-items: center;">
      <div class="row w-100">
        <div class="d-flex col-md-4">
          <span class="font-weight-bold" style="min-width: 100px">Học viên: </span>
          <b>{{ mark_essay?.student?.name }}</b>
        </div>
        <div class="d-flex col-md-4 my-3 my-md-0">
          <span class="font-weight-bold" style="min-width: 100px">Số điện thoại:</span>
          <b>{{ mark_essay?.student?.phone }}</b>
        </div>
        <div class="d-flex col-md-4 mb-3 mb-md-0">
          <span class="font-weight-bold" style="min-width: 100px">Buổi học:</span>
          <b>{{ lesson }}</b>
        </div>
      </div>
    </div>
    <div class="rounded-lg mt-5">
      <CommentAnswerHistory v-if="answerOfStudent.length > 0 && !isCambridgeMentor()"
          :group-questions="answerOfStudent"
          :typeMark="score_max_homework"
          :course_student_id="course_student_id"
      />
     <CommentAnswerKidHistory v-if="answerOfStudent.length > 0 && isCambridgeMentor()"
      :group-questions="answerOfStudent"
      :typeMark="score_max_homework"
      :course_student_id="course_student_id"
     >
     </CommentAnswerKidHistory>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADMIN_HOMEWORK_V2,
  ADMIN_HOMEWORK,
  ADMIN_GET_HISTORY_HOMEWORK,
} from "@/core/services/store/course/classes.module";
import moment from "moment-timezone";
import CommentAnswerHistory from "./CommentAnswerHistory.vue";
import {AnswerStudent} from "@/view/pages/classes/model/AnswerStudent";
import {Cambridge_Mentor_ID} from "@/core/option/typeCenterBill"; 
import CommentAnswerKidHistory from "./CommentAnswerKidHistory.vue";

export default {
  components: {CommentAnswerKidHistory, CommentAnswerHistory },
  data() {
    return {
      mark_essay: {
        isLoadingMarkEssay: true,
        student: {},
        data: [],
      },
      lesson: null,
      classroom_id: null,
      student_id: null,
      course_student_id: null,
      time_send_homework: null,
      loading: false,
      score_max_homework: 0,
      answerOfStudent: [],
      is_redo: this.$route.query.type == 'redo' ? true : false
    }
  },
  async mounted() {
    this.lesson = this.$route.query.lesson;
    this.classroom_id = this.$route.query.classroom_id
    this.student_id = this.$route.query.student_id
    this.course_student_id = Number(this.$route.query.course_student_id)
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản lý lớp học", route: 'schedule-class', id: this.$route.query.classroom_id },
      { title: "Lịch sử chấm BTVN lần " + (this.$route.query.type == 'redo' ? "2" : "1") }
    ]);
    await this.getMarkStudent()
  },
  methods: {
    getMarkStudent() {
      this.isloadingHomework = true;
      const url = this.$route.query.type == 'redo' ? ADMIN_HOMEWORK_V2 : ADMIN_HOMEWORK;
      this.$store.dispatch(url, {
        classroom_id: this.classroom_id,
        lesson: this.lesson,
        type: 'homework',
        user_id: this.student_id
      }).then((res) => {
        if (!res.error) {
          if (res.data.length > 0) {
            this.mark_essay.student = res.data[0];
            this.score_max_homework = res.data[0].score_max_homework
            let payload = {
              course_student_id: this.course_student_id,
              lesson: this.lesson,
              order: this.is_redo ? 2 : 1
            }
            this.$store.dispatch(ADMIN_GET_HISTORY_HOMEWORK, payload).then((res) => {
              if (!res.error) {
                this.mark_essay.data = res.data;
                console.log(this.mark_essay.data, 'mark_essay.data')
                this.answerOfStudent = this.mark_essay?.data.map((e)=>{
                  let typeAnswer = e?.groupQuestion?.type
                 return  new AnswerStudent(e.comment,e.comments,e.groupQuestion,e.outcomes_id,e.overall_result_id,e.score,e.score_detail,e.status_mark,e.answer,e.test_id,e.type,e.user_id,typeAnswer)
                })
                console.log(this.answerOfStudent, 'answerOfStudent');
                this.mark_essay.isLoadingMarkEssay = false;
              }
            }).catch((e) => {
              console.log(e, 'error')
            });
            this.time_send_homework = moment(this.mark_essay.student.test.created_at).format('HH:mm:ss YYYY-MM-DD')
            this.isLoadingMarkEssay = false;
          }
        }
      }).catch((e) => {
        console.log(e, 'error')
      });
    },
    isCambridgeMentor() {
      const idCenter = this.$route.query.center_id;
      return +idCenter === Cambridge_Mentor_ID
    }
  },

}
</script>

<style lang="scss" scoped>
.btn-custom {
  padding: 8px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  align-self: center;

  :hover {
    background-color: burlywood;
  }
}
</style>